module.exports = __webpack_public_path__ + "img/text.2ebd8b4d.png";